export class LocalStorageService {
    static getSession() {
        const ls = localStorage.getItem("ls.session")
        return ls ? JSON.parse(ls) : null
    }

    static setSession(session: any) {
        const ls = localStorage.setItem("ls.session", JSON.stringify(session))
    }

    static getUserRole(): string {
        const ls = localStorage.getItem("ls.session")
        return ls ? JSON.parse(ls).user?.role[0] : null
    }
    static getUserName(): string {
        const ls = localStorage.getItem("ls.session")
        return ls ? `${JSON.parse(ls).user?.firstName} ${JSON.parse(ls).user?.lastName ?? ''}`  : ""
    }
    static clearSession() {
        localStorage.clear()
    }

    static getIsGodUser() {
        const ls = localStorage.getItem("mode")
        return ls == 'god'
    }

    static getLogo() {
        const ls = localStorage.getItem("ls.session")
        return ls ? JSON.parse(ls).logo : null
    }

}